<template>
<div :class="[!openCard ? 'dropdown_code_contract' : 'dropdown_code_expand']">
    <div :id="'code_container_' + ariaId" class="language-response extra-class">
        <div style="text-align: right; padding: 16px 16px 0px 16px;">
        <i class="pi icon-technical-expand" style="width: 14px; height: 20px; background: #C4C4C4; margin-right: 16px; cursor: pointer;" :style="{'rotate': !openCard ? '180deg' : ''}" @click="handleHeight()"/>
        <i id="button1" class="pi icon-technical-copy" style="width: 18px; height: 20px; background: #C4C4C4; cursor: pointer;" @click="CopyToClipboard(ariaId + '_code')" />
        </div>
        <div :id="ariaId + '_code'">
            <slot></slot>
        </div>
        <div style="position: height: 173px; background: transparent linear-gradient(180deg, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box; border-radius: 7px; text-align: center; padding: 24px">
            <span style="font-size: 20px; font-wight: 600; letter-spacing: 0px; color: #25B83D; margin: 24px; padding: 10px; cursor: pointer;" @click="handleHeight()">
                {{ !openCard ?  'Expandir código' : 'Contraer código' }}
            </span>
        </div>
    </div>
</div>

</template>
<script>
import UniqueComponentId from 'primevue/utils/UniqueComponentId'
export default {
    name: 'code',
    data: () => {
        return {
            openCard: false
        }
    },
    methods: {
        handleHeight() {
            if (this.openCard) {
                this.openCard = false
            } else {
                this.openCard = true
            }
        },
        CopyToClipboard(ariaId) {
            var range = document.createRange();
            range.selectNode(document.getElementById(ariaId));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
        }
    },
    computed: {
        ariaId() {
            return UniqueComponentId();
        }
    }
}
</script>
<style>
.dropdown_code_contract {
    div[id^=code_container_] {
        pre, pre[class*="language-"] {
            max-height: 206px !important;
        }
    }
}

.dropdown_code_expand {
    div[id^=code_container_] {
        pre, pre[class*="language-"] {
            height: auto !important;
        }
    }
}

.expand-code {
    max-height: 314px !important;
}

.language-response {
  height: auto !important;
}
</style>